import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types'
import '../PrayTimesTable.css'
import prayTimes from '../PrayTimes'
import * as DateConverter from "../services/date-convert.service";
import moment from "moment";
import {isDST} from "../services/dst.service"

function PrayTimesTable(props) {
    const [monthDetail, setMonthDetail] = useState([]);

    useEffect(() => {
        if (props.month <= 12) {
            DateConverter.getGregorianMonthDetail(props.year, props.month)
                .then(response => {
                    setMonthDetail(response);
                }).catch(console.log)
        } else {
            DateConverter.getHijriMonthDetail(props.year,props.month - 12)
                .then(response => {
                    setMonthDetail(response);
                }).catch(console.log)
        }
    }, [props.month, props.customLogo])

    const renderTable = () => {

        return monthDetail.map((currentDate, index) => {
            prayTimes.setMethod(props.method);
            prayTimes.adjust({asr: props.asrMethod});
            let offset = 0;
            let the_date = new Date(moment(currentDate.greg, 'MMM DD YYYY, ddd').format('YYYY-MM-DD'))
           
            if(isDST(props.country,props.state_obtained,the_date))
            {
                //offset = props.dst * 60;
                offset = 1 * 60;
            }
             
            prayTimes.tune({
                sunrise: offset,
                sunset: offset,
                fajr: offset,
                dhuhr: offset,
                asr: offset,
                maghrib: offset,
                isha: offset
            });
            const times = prayTimes.getTimes(currentDate.greg, [props.lat, props.lng], props.timeZone, 0, props.format);
            return (
                <tr key={index}>
                    {props.dateMode === "greg" &&
                        <td>{moment(currentDate.greg, 'MMM DD YYYY, ddd').format('D')}</td>
                    }
                    {props.dateMode === "hijri" &&
                        <td>{currentDate.hijri}</td>
                    }
                        <td>{moment(currentDate.greg, 'MMM DD YYYY, ddd').format('ddd')}</td>
                    {
                        props.dateMode === "greg" &&
                        <td>{currentDate.hijri}</td>
                    }
                    {
                        props.dateMode === "hijri" &&
                        <td>{moment(currentDate.greg, 'MMM DD YYYY, ddd').format('MMM DD, YYYY')}</td>
                    }
                    <td>{times.fajr}</td>
                    <td>{times.sunrise}</td>
                    <td>{times.dhuhr}</td>
                    <td>{times.asr}</td>
                    <td>{times.maghrib}</td>
                    <td>{times.isha}</td>
                </tr>
            );
        });
    }


    return (


        <div className="ramadan-main-content" id="ramadan-main-content" style={{
            backgroundColor: '#fff',
            width: '210mm',
            maxHeight: '297mm',
            marginLeft: 'auto',
            marginRight: 'auto'
        }}>
            <div className="ramadan-calendar-header">
                <div className="ramadan-islamicity-logo left">
                    <img src={props.customLogo} id="custom-logo-img"/>
                </div>
                <div className="ramadan-header-middle">
                    <p>{props.customTitle}</p>
                </div>
                <div className="ramadan-header-right">
                    <p>{props.monthName} {props.year}<br/> {props.address}</p>
                </div>
            </div>
            <div style={{"clear": "both"}}/>
        
            <div className={props.style != "style1" ? "PrayTimesTable ramadan-calendar" : "PrayTimesTable ramadan-calendar ramadan-calendar-large"} style={ props.style != "style1" ? {backgroundImage: `url(${process.env.PUBLIC_URL + "/images/" + props.style + "/main_bg.jpg"})`} : {} }>
                <div className="table-wrapper">
                    {   props.style != "style1" &&          
                        <div className="ramadan-mosque-img" >
                            <img src={process.env.PUBLIC_URL + "/images/common/mosque_img.png"} alt=""/>
                        </div> 
                    }
                    <div className="ramadan-table">
                        <table className="fl-table">
                            <thead>
                            <tr>
                                <th>{props.monthName}</th>
                                <th>DAY</th>
                                <th>DATE</th>
                                <th>FJR</th>
                                <th>SUNRISE</th>
                                <th>DHR</th>
                                <th>ASR</th>
                                <th>MGB</th>
                                <th>ISH</th>
                            </tr>
                            </thead>
                            <tbody>
                            {renderTable()}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>

            <div className="ramadan-calendar-footer">
                <p>{props.customFooter}</p>
                <span>Powered by <a style={{"text-decoration": "none", "color": "#B8A562"}}
                                    href="https://www.islamicity.org/">IslamiCity.org</a></span>
            </div>
        </div>

    );

}

PrayTimesTable.defaultProps = {
    date: new Date(),
    format: '12hNS',
    style: 'style1'
}

PrayTimesTable.propTypes = {
    date: PropTypes.instanceOf(Date),
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    timeZone: PropTypes.number.isRequired,
    dst: PropTypes.number.isRequired,
    country:  PropTypes.string,
    state_obtained:  PropTypes.string,
    format: PropTypes.string.isRequired,
    method: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    style: PropTypes.string.isRequired,
    customLogo: PropTypes.string,
    customTitle: PropTypes.string,
    customFooter: PropTypes.string,
    monthName: PropTypes.string,
    month: PropTypes.string,
    monthDetail: PropTypes.string,
    dateMode: PropTypes.string,
    year: PropTypes.string,
    convertedDates: PropTypes.string,
    asrMethod: PropTypes.string,
}

export default PrayTimesTable;